import { useEvents } from '@/utils/useEvents';

export const initDebug = () => {
  const events = useEvents();

  events.user.subscribe('debug.send', (payload) => {
    events.user.publish('debug.reply', payload);
  });

  // @ts-ignore
  window['_DEBUG'] = {
    userTabCount: () => {
      const key = (Math.random() + 1).toString(36).substring(7);

      let tabCount = 0;

      events.user.subscribe('debug.reply', (payload) => {
        if (payload === key) {
          tabCount++;
        }
      });

      events.user.publish('debug.send', key);

      setTimeout(() => {
        events.user.unsubscribe('debug.reply');

        console.log('Tabs', tabCount);
      }, 200);
    },
  };
};
